import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';

const Resource = props => {
  const className = classnames('Resource', {
    'url': props.isWebsite,
    'document': props.isDocument,
    'is-empty': props.isEmpty
  });

  return (
    <div className={className}>
      <p className="date">{props.since}</p>
      <h5>{props.title}</h5>
      <p className="author">{props.authorName}</p>
      <a className="Link" href={props.url} target="_blank"></a>
    </div>
  );
};

Resource.propTypes = {
  title: PropTypes.string,
  authorName: PropTypes.string,
  isWebsite: PropTypes.bool,
  isDocument: PropTypes.bool,
  since: PropTypes.string,
  url: PropTypes.string,
  isEmpty: PropTypes.bool
};

export default Resource;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ResourcesList/Resource/index.js
 **/